import Axios from 'axios';
import Approuter from '../router'
import Alert from '../util/alert'
import {AUTH_TOKEN} from "../util/constants";
import {AUTH_LOGOUT} from "../store/actions/auth";
import {LOGIN} from "../router/routes";
import store from '../store';
import {Errors} from "../constants";

function handleSessionExpiration(err) {
    let errorMsg;
    if (err.response && err.response.data) {
        if (err.response.data.message)
            errorMsg = err.response.data.message;
        else if (err.response.data.errors)
            errorMsg = err.response.data.errors;
        else errorMsg = Errors.SERVER_ERROR;
    } else errorMsg = Errors.SERVER_ERROR;
    if (!err.response) {
        errorMsg = Errors.SERVER_UNAVAILABLE;
        Alert.mensajeError(null, Errors.SERVER_UNAVAILABLE);
    } else if (err.response.data.status === "UNAUTHORIZED" || err.response.status === 403 || err.response.data.status === 403) {
        store.dispatch(AUTH_LOGOUT);
        Approuter.router.push(LOGIN.route).catch(err => {
        });
    }
    throw errorMsg;
}

export default {
    init() {
        Axios.defaults.baseURL = process.env.SVC_URL;
    },
    putAuthorization(conf) {
        const token = localStorage.getItem(AUTH_TOKEN);
        if (token) {
            if (!conf) {
                conf = {};
            }
            if (!conf.headers) {
                conf.headers = {};
            }
            conf.headers['Authorization'] = "Bearer " + token;
        }
        return conf;
    },
    get(url, conf) {
        conf = this.putAuthorization(conf);
        return Axios.get(url, conf)
            .catch((err) => {
                handleSessionExpiration(err);
            })
    },
    put(url, data, conf) {
        conf = this.putAuthorization(conf);
        return Axios.put(url, data, conf)
            .catch((err) => {
                handleSessionExpiration(err);
            })
    },
    patch(url, data, conf) {
        conf = this.putAuthorization(conf);
        return Axios.patch(url, data, conf)
            .catch((err) => {
                handleSessionExpiration(err);
            })
    },
    post(url, data, conf, handleExp = true) {
        conf = this.putAuthorization(conf);
        return Axios.post(url, data, conf)
            .catch((err) => {
                if (handleExp) {
                    handleSessionExpiration(err);
                } else
                    throw err;
            })
    },
    delete(url, conf) {
        conf = this.putAuthorization(conf);
        return Axios.delete(url, conf)
            .catch((err) => {
                handleSessionExpiration(err);
            })
    },
    downloadExcel(url, data, conf) {
        conf = this.putAuthorization(conf);
        conf.responseType = 'blob';
        conf.headers['Accept'] = 'application/ms-excel.spreadsheetml.sheet';
        conf.headers['Content-Type'] = 'application/json';
        return Axios.post(url, data, conf)
            .catch((err) => {
                handleSessionExpiration(err);
                throw err;
            })
            .catch(err => {
                if (err.response) {
                    throw err;
                }
            })
    },
}



// WEBPACK FOOTER //
// ./src/services/rest.js